// extracted by mini-css-extract-plugin
export default {"grid":"Charts-module__grid","stale":"Charts-module__stale","placeholder":"Charts-module__placeholder"};